import React from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';

import ButtonContent from '../ButtonContent';
import { FileSelection } from '../../containers/Files'
import NavigationTabs from '../nav/NavigationTabs';
import { updateReferenceCode } from "../../store/actions/auth";
import { adminUpdate, deleteBrand, fetchAll, getBrand } from "../../store/actions/brand";
import { showLoader } from "../../store/actions/loader";
import withAuth from '../../hocs/withAuth';
import { AlertJsMessage } from '../../helpers.js'

class EditTrainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandId: '',
      activeCompaignTag: '',
      isActive: true
    }
  }

  componentDidMount() {
    this.props.fetchAll();
  }

  selectBrand = (field) => event => {
    this.clearFields();
    this.setState({
      ...this.state,
      [field]: event.target.value
    }, () => {
      this.props.getBrand(event.target.value)
        .then(details => {
          this.setState({ 
            ...details, 
            brandId: details._id,
            isContentRestrict: details.isContentRestrict,
            isFullLibraryVisible: details.isFullLibraryVisible,
            activeCompaignTag: details.activeCompaignTag ? details.activeCompaignTag : '',
            isActive: !details.isDeleted
          })
        });
    });
  }

  clearFields = () => {
    this.setState({
      creatorId: '',
      referralImgUrl: '',
      referralFileId: 0,
      referralLink: '',
      activeCompaignTag:'',
      brandId: '',
      brand: ''
    });
    this.productFile && this.productFile.clearImage();
    this.referralFile && this.referralFile.clearImage();
  }

  updateReferrenceData() {
    this.props.removeError();
    const { updateReferenceCode } = this.props;
    if (this.referralFile.state.type === 'library') {
      this.props.showLoader();
      const selectedFile = this.referralFile.state.selectedFile
      let data = {
        referralImgUrl: selectedFile.url,
        referralFileId: selectedFile._id,
        _id: this.state.creatorId
      };
      updateReferenceCode(
        data
      ).then((response) => {
      });
    } else {
      if (!this.referralFile.state.previewImageSrc) {
        AlertJsMessage('Please select or upload an image for the referral link.');
        return;
      }
      this.props.showLoader();
      this.referralFile.submitNewFile().then((file) => {
        let data = {
          referralImgUrl: file.url,
          referralFileId: file._id,
          _id: this.state.creatorId
        };
        updateReferenceCode(
          data
        ).then((response) => {
        });
      })
    }
  }

  async updateBrandDetatils() {
    await this.props.updateBrand(
      this.state.brandId,
      { 
        activeCompaignTag: this.state.activeCompaignTag,
        isContentRestrict: this.state.isContentRestrict,
        isFullLibraryVisible: this.state.isFullLibraryVisible
      }
    )
  }

  async toggleVisibility(e) {
    this.props.updateBrand(
      this.state.brandId,
      { isDeleted: !e.target.checked }
    ).then((res) => {
      this.setState({
        ...this.state,
        isActive: !res.isDeleted
      })
    })
  }

  deleteBrand() {
    this.props.deleteBrand(this.state.brandId)
      .then(() => {
        this.props.fetchAll();
        this.clearFields();
        this.handleClose();
        window.location.reload();
      })
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.value,
		});
	};

  handleRestrictApp = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};

  handleFullLibraryVisible = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};

  
  render() {
    const { listing, isAgency} = this.props;
   
    return (
      <div>
        <NavigationTabs
          title={`Manage Trainers`}
          set={`manageTrainers`}
          subtitle={`Update/Delete Trainer`}
          activeRoute={`/manageTrainers/edit`}/>
        <div>
          <div>
            <div >
              <div style={{ display: 'inline-flex', width: '100%', justifyContent: 'space-between' }}>
                <div style={{ width: '45%' }}>
                  <TextField
                    select
                    label="Select Trainer"
                    value={this.state.brand}
                    onChange={this.selectBrand('brand')}
                    margin="dense"
                    variant="outlined"
                  >
                    {listing && listing.map(option => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.displayName}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.brandId !== '' ?
          <div>
            <div>
              <div style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}>
                <div style={{ width: '45%' }}>
                  <h4>Active Campaign Tag</h4>
                  <TextField
                      style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
                      label=""
                      value={this.state.activeCompaignTag}
                      onChange={this.handleChange('activeCompaignTag')}
                      margin="dense"
                      variant="outlined"
                    />
                </div>
                <div style={{ width: '45%' }}>
                    <h4>App Content</h4>
                    <FormControlLabel
                        control={
                          <Checkbox
                            onChange={this.handleRestrictApp('isContentRestrict')}
                            checked = {this.state.isContentRestrict}
                            inputProps={{
                              'name': 'isContentRestrict',
                            }}
                          />
                        }
                        name = "isContentRestrict"
                        label="Restrict App to this brand"
                        />
                  </div>
              </div>

              <div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								

								<div style={{ width: '45%' }}>
									<h4>Show Full Fitbanx Library</h4>
									<FormControlLabel
											control={
												<Checkbox
													onChange={this.handleFullLibraryVisible('isFullLibraryVisible')}
													checked={this.state.isFullLibraryVisible}
													inputProps={{
														'name': 'isFullLibraryVisible',
													}}
												/>
											}
											name = "isFullLibraryVisible"
											label="Show Full Fitbanx Library to this brand"
											/>
								</div>

								

							</div>

              <div style={{ width: '45%', marginTop: '10px', marginBottom: '10px' }}>
                <Button
                  onClick={() => { this.updateBrandDetatils() }}
                  variant="contained"
                  color="primary">
                  <ButtonContent
                    text="Save"
                    icon="chevron-right" />
                </Button>
              </div>
            </div>
            <hr />
            <hr />
            <h3>Web Referral Link Page</h3>
            <div>
              <div>
                <h4>Upload Photo</h4>
                <FileSelection
                  userData={{ _id: this.state.creatorId }}
                  fileType="image"
                  category="profile"
                  isBrand={true}
                  selectedFileId={this.state.referralFileId}
                  ref={(ref) => { this.referralFile = ref ? ref.getWrappedInstance() : null }}
                />
              </div>
              <div style={{ width: '45%', marginTop: '10px', marginBottom: '10px' }}>
                <Button
                  onClick={() => { this.updateReferrenceData() }}
                  variant="contained"
                  color="primary">
                  <ButtonContent
                    text="Save"
                    icon="chevron-right" />
                </Button>
              </div>
            </div>
            <hr />
            <div style={{ display: 'flex' }}>
              <div style={{ width: '50%', marginTop: '10px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isActive}
                      onChange={(e) => {
                        this.toggleVisibility(e)
                      }}
                      value="" />
                  }
                  label="Active"
                />
              </div>
              {/* <div style={{ width: '50%', marginTop: '10px' }}>
                <Button
                  onClick={() => { this.handleOpen() }}
                  variant="contained"
                  color="primary"
                  style={{ float: 'right', background: 'red' }}
                >
                  <ButtonContent
                    text="Delete Trainer"
                    icon="chevron-right" />
                </Button>
              </div> */}
            </div>
            <Modal
              className="modal show"
              style={{ alignItems: 'center', justifyContent: 'center' }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={this.state.open}
              onClose={this.handleClose}>
              <div className="modalBody modal-content" style={{ width: 500, textAlign: 'center' }}>
                <ModalHeading
                  text={'Delete Trainer'}
                  closeModal={() => this.setState({ open: false })} />
                <div className="modalContent">
                  <p>Are you sure you want to delete {this.state.displayName} trainer?</p>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button style={{ width: '30%', marginTop: '10px', marginRight: '10px' }} onClick={() => this.deleteBrand()} variant="contained" color="primary">
                      Yes
                        </Button>
                    <Button style={{ width: '30%', marginTop: '10px' }} onClick={() => this.handleClose()} variant="contained">
                      No
                        </Button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
          : ''}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    errors: state.errors,
    listing: state.brand && state.brand.trainerListing,
    brand: state.brand && state.brand.detail
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deleteBrand: (brand_id) => {
      return dispatch(deleteBrand(brand_id));
    },
    fetchAll: () => {
      return dispatch(fetchAll(true, false));
    },
    getBrand: (data) => {
      return dispatch(getBrand(data));
    },
    updateBrand: (brand_id, brandData) => {
      return dispatch(adminUpdate(brand_id, brandData));
    },
    updateReferenceCode: (data) => {
      return dispatch(updateReferenceCode(data));
    },
    showLoader: () => {
      return dispatch(showLoader());
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(EditTrainer));



// WEBPACK FOOTER //
// ./src/components/manageBrands/TrainerEdit.js